import React from 'react';

const { Provider, Consumer } = React.createContext('Dashboard');

export { Provider, Consumer };
